export default __webpack_public_path__ + "9a1218c6b685ca387a11c86e197903b5.webp";